module.exports = __webpack_public_path__ + "media/images/package-individual-c79cad89cb4d402d894cfffd238c2e72.svg";